import React from 'react';
import Button from '@mui/joy/Button';
import { Card, CardActions, Divider, Grid, Typography, Box } from "@mui/joy";
import Sheet from '@mui/joy/Sheet';
import { BreadcrumbTwo } from '../../component/common/Breadcrumb';



const biddata = [
  {
    id: "2RTO782U13",
    categories: "Plumbing",
    subcategories: "Pipe Installation",
    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    Date: "05/01/2025",
    Time: "Morning 9 to 2",
    location: "123, Street Name, Landmark, City"
  },
  {
    id: "2RTO782U13",
    categories: "Plumbing",
    subcategories: "Pipe Installation",
    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    Date: "05/01/2025",
    Time: "Morning 9 to 2",
    location: "123, Street Name, Landmark, City"
  },
  {
    id: "2RTO782U13",
    categories: "Plumbing",
    subcategories: "Pipe Installation",
    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    Date: "05/01/2025",
    Time: "Morning 9 to 2",
    location: "123, Street Name, Landmark, City"
  },
  {
    id: "2RTO782U13",
    categories: "Plumbing",
    subcategories: "Pipe Installation",
    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    Date: "05/01/2025",
    Time: "Morning 9 to 2",
    location: "123, Street Name, Landmark, City"
  },
  {
    id: "2RTO782U13",
    categories: "Plumbing",
    subcategories: "Pipe Installation",
    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    Date: "05/01/2025",
    Time: "Morning 9 to 2",
    location: "123, Street Name, Landmark, City"
  },
  {
    id: "2RTO782U13",
    categories: "Plumbing",
    subcategories: "Pipe Installation",
    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    Date: "05/01/2025",
    Time: "Morning 9 to 2",
    location: "123, Street Name, Landmark, City"
  },






]


const BitCard = () => {


  return (
    <>

      {/* <BreadcrumbTwo/> */}

      <Grid
        container
        spacing={{ xs: 0, md: 0 }}
        columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
        sx={{ flexGrow: 1, width: '100%' }}
      >

        {!biddata && biddata.length() >= 0 ? '' : biddata.map((data, index) => (
          <Grid key={index} xs={12} sm={12} md={12} lg={12} sx={{ marginTop: "2rem" }}>

            <Card
              size="lg"
              variant="solid"

              sx={{
                width: '100%',
                display: 'grid',
                gridTemplateColumns: {
                  xs: '1fr',
                  sm: 'repeat(auto-fill, minmax(300px, 1fr))',
                  md: 'repeat(auto-fill, minmax(600px, 1fr))',
                  lg: 'repeat(auto-fill, maxmax(1258px, 1fr))',
                },
                gap: 2,
                borderRadius: "20px",
                border: "1px solid #666666",
                backgroundColor: "#fff"
              }}
            >



              <Box sx={{
                display: 'flex',
                justifyContent: 'space-between',
                gap: 1.5,
                width: '100%',
                maxWidth: '1207px',
                margin: 'auto',

              }}
              >
                <Box>
                  <Typography level="h3" sx={{ fontWeight: 'lg' }}>{data.id}</Typography>
                </Box>
                <Button variant="outlined" color="neutral"
                  sx={{
                    backgroundColor: " #c8e0cd",
                    color: "#28A745",
                    padding: "10px 50px",
                    "&:hover": {
                      backgroundColor: "#c8e0cd",
                      color: "#28A745", boxShadow: 3,
                    },
                    transition: "all 0.3s ease",
                  }}
                >
                  Bid
                </Button>
              </Box>

              <Divider
                inset="none"
                sx={{
                  width: "100%",
                  height: "3px",
                  borderWidth: 2,
                  border: "0.5 px solid #000000",
                  backgroundColor: "#000000"
                }}
              />

              <Sheet
                sx={{


                  display: 'flex',
                  backgroundColor: "#fff",
                  gap: 2,
                  '& > div': { flex: 1 },
                }}
              >
                <div>

                  <Typography sx={{ fontWeight: 'lg' }}>Categories</Typography>
                </div>

                <div>
                  <Typography level="body-xs" sx={{ fontWeight: 'lg' }}>
                    {data.categories}
                  </Typography>

                </div>
              </Sheet>



              <Sheet
                sx={{


                  display: 'flex',
                  backgroundColor: "#fff",
                  gap: 2,
                  '& > div': { flex: 1 },
                }}
              >
                <div>

                  <Typography sx={{ fontWeight: 'lg' }}>subcategories</Typography>
                </div>

                <div>
                  <Typography level="body-xs" sx={{ fontWeight: 'lg' }}>
                    {data.subcategories}
                  </Typography>

                </div>
              </Sheet>
              <Sheet
                sx={{


                  display: 'flex',
                  backgroundColor: "#fff",
                  gap: 2,
                  '& > div': { flex: 1 },
                }}
              >
                <div>

                  <Typography sx={{ fontWeight: 'lg' }}>Description</Typography>
                </div>

                <div>
                  <Typography level="body-xs" sx={{ fontWeight: 'lg' }}>
                    {data.description}
                  </Typography>

                </div>
              </Sheet>
              <Sheet
                sx={{

                  display: 'flex',
                  backgroundColor: "#fff",
                  gap: 2,
                  '& > div': { flex: 1 },
                }}
              >
                <div>

                  <Typography sx={{ fontWeight: 'lg' }}>Date & Time</Typography>
                </div>

                <div>
                  <Typography level="body-xs" sx={{ fontWeight: 'lg' }}>
                    {data.Date} & {data.Time}
                  </Typography>

                </div>
              </Sheet>
              <Sheet
                sx={{


                  display: 'flex',
                  backgroundColor: "#fff",
                  gap: 2,
                  '& > div': { flex: 1 },
                }}
              >
                <div>

                  <Typography sx={{ fontWeight: 'lg' }}>Location</Typography>
                </div>

                <div>
                  <Typography level="body-xs" sx={{ fontWeight: 'lg' }}>
                    {data.location}
                  </Typography>

                </div>
              </Sheet>

              <Divider
                inset="none"
                sx={{
                  width: "100%",
                  height: "2px",
                  borderWidth: 2,
                  border: "0.5 px solid #000000",
                  backgroundColor: "#000000"
                }}
              />
              <CardActions sx={{ display: 'flex', justifyContent: "center", justifyItems: "center" }}>

                <Button
                  sx={{
                    padding: "12px", maxWidth: "250px", textAlign: "center",
                    backgroundColor: "#28A745",
                    "&:hover": {
                      backgroundColor: "#28A745",
                      color: "#ffffff", boxShadow: 3,
                    },

                  }}>Start now</Button>
              </CardActions>
            </Card>


          </Grid>
        ))

        }

      </Grid>


    </>
  );
}
export default BitCard;